<template>
	<div>
		<el-empty v-if="data && !data.length > 0" description="暂无规划"></el-empty>

		<el-card class="table-card" shadow="always" v-for="item in data" :key="item.assetId">
			<el-descriptions class="margin-top" :column="2" border>
				<el-descriptions-item label="规划编号">{{ item.planNo }}</el-descriptions-item>
				<el-descriptions-item label="规划类型">{{ item.planType }}</el-descriptions-item>
				<el-descriptions-item label="规划目标" :span="2">{{ item.planTarget }}</el-descriptions-item>
				<el-descriptions-item label="开始日期">{{ item.startDate }}</el-descriptions-item>
				<el-descriptions-item label="结束日期">{{ item.endDate }}</el-descriptions-item>
				<el-descriptions-item label="责任部门">{{ item.department }}</el-descriptions-item>
				<el-descriptions-item label="责任人">{{ item.responsiblePerson }}</el-descriptions-item>
				<el-descriptions-item label="规划状态">{{ item.status }}</el-descriptions-item>
				<el-descriptions-item label="执行进度">{{ item.progress }}</el-descriptions-item>
			</el-descriptions>

			<div class="progress">
				<div>执行进度:</div>
				<div class="progress-info">
					<el-progress :stroke-width="8" :percentage="item.progress"></el-progress>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: 'AssetLedgerPlanningInfo',
		components: {},
		props: {
			data: {
				type: Array,
				default: () => [],
			},
		},
	};
</script>

<style scoped lang="scss">
	.table-card {
		margin-bottom: 10px;
	}

	.progress {
		margin-top: 10px;
		color: #1c1c1c;
		font-size: 14px;
		font-weight: 500;
		&-info {
			margin-top: 8px;
			width: 100%;
		}
	}
</style>
